import { render, staticRenderFns } from "./examinationSupervision.vue?vue&type=template&id=a6a5c7e6"
import script from "./examinationSupervision.vue?vue&type=script&lang=js"
export * from "./examinationSupervision.vue?vue&type=script&lang=js"
import style0 from "./examinationSupervision.vue?vue&type=style&index=0&id=a6a5c7e6&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports